import { ActionTypes } from "../constants/action_types"

export const setLoginUser = (value) => {
    return {
        type: ActionTypes.SET_LOGIN_USER,
        user: value
    }
}

export const removeLoginUser = (value) => {
    return {
        type: ActionTypes.REMOVE_LOGIN_USER,
        user: value
    }
}
